import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.timers";
import Vue from 'vue';
import { addClass, removeClass } from './dom';
var hasModal = false;

var getModal = function getModal() {
  // 为什么这里是server的话，下面的代码不执行呢?
  if (Vue.prototype.$isServer) {
    return;
  }

  var modalDom = PopupManager.modalDom;

  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;
    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });
    modalDom.addEventListener('click', function () {
      if (PopupManager.doOnModalClick) {
        PopupManager.doOnModalClick();
      }
    });
  }

  return modalDom;
}; // 一个map


var instances = {}; // 类似于toast来控制的?

var PopupManager = {
  zIndex: 2000,
  modalFade: true,
  getInstance: function getInstance(id) {
    return instances[id];
  },
  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },
  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },
  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },
  // todo 如何做类型标记呢
  modalStack: [],
  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];

    if (!topItem) {
      return;
    }

    var instance = PopupManager.getInstance(topItem.id);

    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },
  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
    if (Vue.prototype.$isServer) {
      return;
    }

    if (!id || zIndex === undefined) {
      return;
    }

    this.modalFade = modalFade;
    var modalStack = this.modalStack;

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];

      if (item.id === id) {
        return;
      }
    }

    var modalDom = getModal();
    addClass(modalDom, 'v-modal');

    if (this.modalFade && !hasModal) {
      addClass(modalDom, 'v-modal-enter');
    }

    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return addClass(modalDom, item);
      });
    }

    setTimeout(function () {
      removeClass(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      // @ts-ignore
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      // @ts-ignore
      modalDom.style.zIndex = zIndex;
    } // @ts-ignore


    modalDom.style.display = '';
    this.modalStack.push({
      id: id,
      zIndex: zIndex,
      modalClass: modalClass
    });
  },
  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = getModal();

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];

      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return removeClass(modalDom, item);
          });
        }

        modalStack.pop();

        if (modalStack.length > 0) {
          // @ts-ignore
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        addClass(modalDom, 'v-modal-leave');
      }

      setTimeout(function () {
        if (modalStack.length === 0) {
          // @ts-ignore
          if (modalDom.parentNode) {
            // @ts-ignore
            modalDom.parentNode.removeChild(modalDom);
          } // @ts-ignore


          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }

        removeClass(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

if (!Vue.prototype.$isServer) {
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      // ESC
      if (PopupManager.modalStack.length > 0) {
        // modalStack顶部内容
        var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];

        if (!topItem) {
          return;
        } // 处理instance


        var instance = PopupManager.getInstance(topItem.id); // 这里是否有问题

        if (instance.closeOnPressEscape) {
          instance.close();
        }
      }
    }
  });
}

export default PopupManager;